import { apiUrl, get } from "./HttpClient";
const controllerPrefix = `${apiUrl}/Products`;

export default {
    getProducts: (categoryId, phoneNumber, token) => {
        if (!phoneNumber) {
            return get(`${controllerPrefix}?categoryId=${categoryId}`, token);
        }
        return get(
            `${controllerPrefix}?categoryId=${categoryId}` +
                `&phoneNumber=${phoneNumber}`,
            token
        );
    },
    getPage: (filter, token) => {
        const query = Object.keys(filter || {}).map(key => `${key}=${filter[key]}`).join('&');
        return get(`/product/paginatedProducts?${query}`, token);
    },
    getProductsSummary: (categoryId, token) => {
        return get(`/product/productsSummary?categoryId=${categoryId}`, token);
    },
    getBySpecification(specificationAttribute, specificationAttributeOption) {
        return get(
            `/product/index?specificationAttribute=${specificationAttribute}&specificationAttributeOption=${specificationAttributeOption}`
        );
    }
};
